<template>
  <div class="webfoot">
    © 2016-{{toyear}} Take, Inc.
  </div>
</template>
<script>
export default {
  data() {
    return {
      toyear: new Date().getFullYear()
    }
  },
  name: 'webfoot'
}
</script>
<style lang="less" scoped>
  .webfoot {
    width: 100%;
    height: 90px;
    line-height: 90px;
    background: #ccc;
    color: #BBC7CC;
    text-align: center;
    background: #F7FAFB;
  }
</style>
